module.exports = __webpack_public_path__ + "static/media/Zunavish_text.87d74bca.svg";